import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

interface Props {
  /** Overdue period, e.g. "Sierpień 2026". */
  periodLabel: string;
}

/** Shown in place of the deployment bar while the missing-timesheet lock is on:
 *  the app is cut down to Urlopy + Harmonogram until the card goes in. */
export function TimesheetLockBanner({ periodLabel }: Props) {
  return (
    <div className="w-full bg-amber-500 text-amber-950 text-xs font-mono py-1.5 px-4 flex items-center gap-2 z-50 flex-shrink-0">
      <AlertTriangle size={14} className="flex-shrink-0" />
      <span className="font-semibold">
        System zablokowany — brak karty godzin
        {periodLabel ? ` za ${periodLabel}` : ""}
      </span>
      <span className="opacity-80">
        — złóż kartę, aby odblokować pozostałe widoki
      </span>
      <Link to="/timesheets" className="ml-auto underline font-semibold whitespace-nowrap">
        Złóż kartę godzin
      </Link>
    </div>
  );
}
